
import React from "react";
import fields from "../../json/LeaveTypeFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";

const AddLeaveTypeForm = ({
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
}) => {
    const { formdata } = fields;

    const renderField = (field) => {

        if (field.name === "status") {
            return (
                <FormSelect
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    options={field.options}
                    error={errors[field.name]}
                />
            );
        }

        if (field.name === "year") {
            // Generate year options (current year to 10 years back)
            const currentYear = new Date().getFullYear();
            const yearOptions = Array.from({ length: 11 }, (_, i) => {
                const y = currentYear - i;
                return { value: y, label: y.toString() };
            });

            return (
                <FormSelect
                    key={field.name}
                    field={field}
                    value={values[field.name] || currentYear}
                    handleChange={handleChange}
                    options={yearOptions}
                    error={errors[field.name]}
                />
            );
        }

        return (
            <FormInput
                key={field.name}
                field={field}
                value={values[field.name]}
                handleChange={handleChange}
                error={errors[field.name]}
            />
        );
    }

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Add Leave Type</HeadingOne>
        }>
            {formdata.map((field) => renderField(field))}

            <FormSubmitButton
                label="Add Leave Type"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddLeaveTypeForm;
